import TableAddressees from "./TableAddressees";
export default TableAddressees;
export { default as TableAddressees } from './TableAddressees';